module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "loader": "spinner",
      "color": "#36304a",
      "width": 70
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousGoods
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Transport Billing Invoice Form")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.proceedAssignmentProforma(
          _vm.invoiceList.allModuleId,
          0,
          _vm.invoiceList.bookingNo
        )
      }
    }
  }, [_vm._v("Proceed To Proforma")])], 1)], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.invoiceList.allModuleId ? this.invoiceList.allModuleId : '',
      "jobSeriesBanner": this.invoiceList.bookingNo ? this.invoiceList.bookingNo : '',
      "bannerClientName": this.invoiceList.shippingCustomerName ?
        this.invoiceList.shippingCustomerName :
        '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.sentForApproval == '1' && _vm.chnageApprovalStatus != '1') ? _c('h4', {
    staticClass: "mt-3 error"
  }, [_vm._v("\n            Invoice Sent For Approval\n          ")]) : _vm._e(), _vm._v(" "), (_vm.PreviousPerformaList.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body row"
  }, _vm._l((_vm.PreviousPerformaList), function(pre_item, pre_index) {
    return _c('div', {
      key: pre_index,
      staticClass: "col-md-2"
    }, [(pre_item.profarmaSeries) ? _c('b-button', {
      staticClass: "mt-2",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function($event) {
          _vm.getPreviousTallyData(pre_item)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(pre_item.profarmaSeries))])]) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Sales Booking No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.bookingNo),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "bookingNo", $$v)
      },
      expression: "invoiceList.bookingNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.invoiceForm.invoiceStatus),
      callback: function($$v) {
        _vm.$set(_vm.invoiceForm, "invoiceStatus", $$v)
      },
      expression: "invoiceForm.invoiceStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper/Customer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.shippingCustomerName),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "shippingCustomerName", $$v)
      },
      expression: "invoiceList.shippingCustomerName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Invoice Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "Date",
      "id": "Date",
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceForm.Date),
      callback: function($$v) {
        _vm.$set(_vm.invoiceForm, "Date", $$v)
      },
      expression: "invoiceForm.Date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pickup Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.fromLocation),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "fromLocation", $$v)
      },
      expression: "invoiceList.fromLocation"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Handover Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.toLocation),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "toLocation", $$v)
      },
      expression: "invoiceList.toLocation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("GRN Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("GRN Number")]), _vm._v(" "), _c('th', [_vm._v("Container Number & Type")]), _vm._v(" "), _c('th', [_vm._v("Fuel Slip No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', [_vm._v("S-Line Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Transportation By")]), _vm._v(" "), _c('th', [_vm._v("Transporter Name")]), _vm._v(" "), _c('th', [_vm._v("Date")])]), _vm._v(" "), _vm._l((_vm.TPTGRNDATA), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.GRNSeries))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(item.containerNo) + "\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(item.multipleContainerType) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.FuelSlipNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.slineSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tptType == 1 ? "Pridel" : "OutSourced"))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(item.transporterName == "" ? "NA" : item.transporterName) + "\n                    ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Loading Date :" + _vm._s(_vm._f("moment")(item.Date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" Reporting Date :" + _vm._s(_vm._f("moment")(item.factoryInDate)) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" Released Date :" + _vm._s(_vm._f("moment")(item.factoryOutDate)) + " ")])])])
  })], 2)])])]), _vm._v(" "), (_vm.invoiceList.allModuleId) ? _c('Profit-Loss', {
    attrs: {
      "PMS_fk_all_module_id": _vm.invoiceList.allModuleId,
      "PMS_jb_series": _vm.invoiceList.bookingNo,
      "PMS_fk_client_id": _vm.invoiceList.clientName,
      "PLAccordianStatus": false,
      "PLAccordianButton": true
    }
  }) : _vm._e(), _vm._v(" "), _c('Assignment-Timeline', {
    attrs: {
      "TMAccordianStatus": false,
      "TMAccordianButton": true,
      "allModuleId": Number(_vm.invoiceList.allModuleId)
    }
  }), _vm._v(" "), (_vm.invoiceList.allModuleId) ? _c('Payment-Summary', {
    attrs: {
      "PMS_fk_all_module_id": _vm.invoiceList.allModuleId,
      "PMS_jb_series": _vm.invoiceList.bookingNo,
      "PMS_fk_client_id": _vm.invoiceList.clientName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.invoiceList.allModuleId) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.invoiceList.allModuleId,
      "type": 'additional-task'
    }
  }) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "mt-3"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Charges")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('span', {
    staticClass: "error mt-4"
  }, [_vm._v("\n                Note : Approval will be required when Selling Rate is less than\n                Quotation Rate.!\n              ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error mt-1"
  }, [_vm._v("* marked heads are mandatory..!")])]), _vm._v(" "), _c('table', {
    staticClass: "table mt-3 table-light table-bordered",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.addQuotationFields
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px !important"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px !important"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px !important"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px !important"
    }
  }, [_vm._v("Quotation Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "250px !important"
    }
  }, [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Invoice Amount(Without Taxes)")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px !important"
    }
  }, [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.quotationData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeCol(index)
        }
      }
    }, [_c('md-icon', [_vm._v("remove")])], 1)], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' && !item.tptTableId ? true : false,
        "list": _vm.$store.getters['common/getAllLedgerList'],
        "option-value": "ledger",
        "option-text": "ledger",
        "placeholder": "Select Particular"
      },
      model: {
        value: (item.otherCharge),
        callback: function($$v) {
          _vm.$set(item, "otherCharge", $$v)
        },
        expression: "item.otherCharge"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' && !item.tptTableId ? true : false,
        "list": _vm.containerMasterData,
        "option-value": "containerType",
        "option-text": "containerType",
        "placeholder": "Select Type"
      },
      model: {
        value: (item.containerType),
        callback: function($$v) {
          _vm.$set(item, "containerType", $$v)
        },
        expression: "item.containerType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' && !item.tptTableId ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.quantity),
        callback: function($$v) {
          _vm.$set(item, "quantity", $$v)
        },
        expression: "item.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": "",
        "type": "number"
      },
      model: {
        value: (item.byInPrice),
        callback: function($$v) {
          _vm.$set(item, "byInPrice", $$v)
        },
        expression: "item.byInPrice"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.qRate),
        callback: function($$v) {
          _vm.$set(item, "qRate", $$v)
        },
        expression: "item.qRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' && !item.tptTableId ? true : false,
        "type": "number"
      },
      model: {
        value: (item.invoiceAmount),
        callback: function($$v) {
          _vm.$set(item, "invoiceAmount", $$v)
        },
        expression: "item.invoiceAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' && !item.tptTableId ? true : false,
        "list": _vm.unitList,
        "option-value": "unitId",
        "option-text": "unitName",
        "placeholder": "Select"
      },
      model: {
        value: (item.unit),
        callback: function($$v) {
          _vm.$set(item, "unit", $$v)
        },
        expression: "item.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1)])
  }))]), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [(_vm.validateTally == false && this.sentForApproval != '1') ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "disabled": _vm.DisableSubmit == '0' &&
        _vm.$store.getters['common/getAllSuccessInvoiceTB'].InvoiceTypeKeyFlag ==
        true ?
        true :
        false
    },
    on: {
      "click": function($event) {
        _vm.submitInvoice('1')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.invoiceForm.invoiceStatus == "0" ?
    "Save & Send To Billing" :
    "Save & Submit") + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.updateTime != 'null' && _vm.editUserName != 'null') ? _c('span', {
    staticStyle: {
      "mmargin-top": "auto",
      "margin-bottom": "auto",
      "padding-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("\n                Last Updated At :\n                "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.updateTime))]), _vm._v(" , By :\n                "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.editUserName))]), _vm._v(" "), _c('br'), _vm._v(" "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .BillingSeriesDataString
  ) ? _c('div', [_vm._v("\n                  Invoice No.\n                  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters["common/getAllSuccessInvoiceTB"]
    .BillingSeriesDataString))]), _vm._v("\n                  genrated.\n                  "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .InvoiceTypeKeyFlag == true
  ) ? _c('span', [_vm._v("Cannot be re-submitted")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [(_vm.validateTally == true && this.sentForApproval != '1') ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.DisableSubmit == '0' &&
        _vm.$store.getters['common/getAllSuccessInvoiceTB'] == true ?
        true :
        false,
      "variant": "dark"
    },
    on: {
      "click": function($event) {
        _vm.submitInvoice('2')
      }
    }
  }, [_vm._v("Send For Approval")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f56ca744","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/invoice.vue
// module id = 2914
// module chunks = 0